<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/z7WcUs/tc-custom/9781460337592.jpg?1705206804539" alt="This image is the cover for the book Risk of Falling"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Risk of Falling
      </h1>
      <p class="bookDescription body article font2">
        <b>A grieving woman finds healing and solace with the help of a handsome building inspector in this heartwarming romance.</b><br/><br/>She’s got thirty days to clean up her mother’s neglected home or she’ll lose it. That’s all city code inspector Will Stone has given her. And it’s not nearly long enough for Suzy Bylin to sort through the lifetime of old treasures and broken keepsakes she’s inherited.<br/><br/>Desperate to keep the place, Suzy must steel herself against the feeling that every time she throws something away, she’s getting rid of a memory of her mom. When she can no longer do it on her own, she has nobody to turn to but Will. And if she can help him through his own family crisis, maybe together they can find more than mutual support and friendship . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Syndi Powell
      </h2>
      
      <p class="authorDescription body article">Syndi Powell started writing stories when she was young to help her find out what happened after the happily ever after in her favorite stories and has made it a lifelong pursuit. She&rsquo;s been reading Harlequin romance novels since she was in her teens and is thrilled to join their team. She lives near Detroit with her husband, stepson, and a cat and dog who believe they run the household. She loves to connect with readers on Twitter @syndipowell or on Facebook.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?269c6724